export const KPI_INDICATORS = [
  { key: "market_penetration_client", label: "Market Penetration of Client" },
  {
    key: "market_penetration_listed_drinks",
    label: "Market penetration on stores listing drinks as KPI",
  },
  {
    key: "avg_core_sku_presence_client_dsf",
    label: "Avg. Core SKU Presence in Client DSF (%)",
  },
  { key: "combo_presence", label: "Combo Presence" },
  { key: "fixed_combo_presence", label: "Fixed Combo Presence" },
  { key: "option_combo_presence", label: "Option Combo Presence" },
  { key: "name_accuracy", label: "Name Accuracy" },
  { key: "avg_image_presence", label: "Avg. Image Presence" },
];

export const STEPS = [
  { title: "Basic" },
  { title: "Weights" },
  { title: "Assignments" },
  { title: "Review" },
];

// Workspace name is sent verbatim as id_client (see useWorkspaceForm.finish),
// so enforce the same normalized-identifier format used by CASS id fields
// (BrandFormModal / FranchiseFormModal). Reject mixed-case / spaces / symbols
// instead of auto-normalizing.
export const WORKSPACE_NAME_PATTERN = /^[a-z0-9_]+$/;
export const WORKSPACE_NAME_HINT =
  "Only lowercase letters, numbers, and underscores (e.g. pepsi_uk).";
